import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { retrySolarSetupRead } from "./solar-read-retry"
import type { SolarProposalRebatesDto } from "../dto/solar-proposal-pricing-steps.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/** The active design's four seller rebates. */
export default function useSolarProposalRebates(
  proposalId: string | undefined,
): UseQueryResult<SolarProposalRebatesDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.rebates(proposalId ?? ``),
    queryFn: () => solarProposalService.getRebates(proposalId ?? ``),
    enabled: Boolean(proposalId),
    retry: retrySolarSetupRead,
  })
}
